module.exports = "<navheader data-mainpage=\"{{mainPage}}\" data-slide=\"slide\"></navheader>\n<div ui-view></div>\n<footermenu></footermenu>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./components/templates/layout.html
 ** module id = 136
 ** module chunks = 0
 **/